import { render, staticRenderFns } from "./answerQuestion.vue?vue&type=template&id=ff80d6b6"
import script from "./answerQuestion.vue?vue&type=script&lang=js"
export * from "./answerQuestion.vue?vue&type=script&lang=js"
import style0 from "./answerQuestion.vue?vue&type=style&index=0&id=ff80d6b6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports